import { render, staticRenderFns } from "./detailIndex.vue?vue&type=template&id=e734988c&scoped=true"
import script from "./detailIndex.vue?vue&type=script&lang=js"
export * from "./detailIndex.vue?vue&type=script&lang=js"
import style0 from "./detailIndex.vue?vue&type=style&index=0&id=e734988c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e734988c",
  null
  
)

export default component.exports